import { render } from "./RunDetail.vue?vue&type=template&id=e88a597c"
import script from "./RunDetail.vue?vue&type=script&lang=js"
export * from "./RunDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__